import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { getCurrentLocale } from '@/i18n/locale';
import { resources } from '@/i18n/resources';

void i18n.use(initReactI18next).init({
  defaultNS: 'common',
  fallbackLng: false,
  interpolation: {
    escapeValue: false,
  },
  lng: getCurrentLocale(),
  resources,
});

export default i18n;
